export default {
  actionType: 1,
  activityType: '',
  address: '',
  addressApt: '',
  addressNumber: '',
  bipartiteCommittee: false,
  communeId: '',
  connectionLink: '',
  country: {},
  countryId: '',
  countryName: '',
  courseCertificate: null,
  courseImage: {},
  courseAgency: '',
  courseModality: '',
  description: '',
  duration: '',
  employeeCourses: [],
  endDate: '',
  endTime: '',
  franchiseType: '',
  friday: false,
  instructorsAttributes: [],
  limitDate: '',
  mandateIndicator: '',
  maxAvailability: '',
  monday: false,
  name: '',
  regionId: '',
  saturday: false,
  status: '',
  senceCode: '',
  senceRegister: false,
  startDate: '',
  startTime: '',
  sunday: false,
  theme: '',
  thursday: false,
  totalValue: 0,
  tuesday: false,
  wednesday: false,
  costPerParticipant: ''
};
